import moment from 'moment';

const useBrowserTimezoneLabel = () => {
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment.tz(browserTimeZone).format('z');
};

export default useBrowserTimezoneLabel;
